import { Injectable } from '@angular/core';
import { ProjectSetupApiService } from '@agent-portal/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { ProjectSetupAction } from '../actions';

@Injectable()
export class ProjectSetupEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(ProjectSetupAction.loadItem),
      exhaustMap(action => {
        return this._apiService.get(action.id).pipe(map(item => ProjectSetupAction.loadItemSuccess({ item })));
      })
    );
  });
  constructor(private _apiService: ProjectSetupApiService, private _actions$: Actions, private _store: Store) {}
}
